var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('vx-order-confirmation',{attrs:{"i18n":_vm.messages.checkout}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-sm-12 col-xs-12 pr-mb-5 pr-xs-1"},[_c('vx-guest-create-account')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b9c954","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order-confirmation.vue
// module id = null
// module chunks = 